<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
export default {
  metaInfo: {
    title: '岳西友辰信息科技有限公司'
  }
}
</script>
<style>
  body{
    margin-left: auto;
    margin-right: auto;
    padding: 0;
    border: 0;
    width: 1200px;
  }
  html,body,#app{
    height: 100%;
  }
  </style>
